// extracted by mini-css-extract-plugin
module.exports = {"boardMembers":"BoardMembersContainer_boardMembers__4bW8I"};